/** Brief 12, K3 Suhbatlar. */
export const ruB12Inbox = {
  "inbox12.title": "Чаты",
  "inbox12.back": "К списку",
  "inbox12.live": "В реальном времени",
  "inbox12.filter.label": "Фильтр",
  "inbox12.filter.new": "Новые · не взяты",
  "inbox12.filter.me": "Мои",
  "inbox12.filter.wait": "Ждут ответа",
  "inbox12.filter.ai": "Ответ AI на проверке",
  "inbox12.filter.late": "Просрочены",
  "inbox12.filter.all": "Все",
  "inbox12.filter.javobsiz24": "Без ответа 24 часа",
  "inbox12.filter.closed": "Закрытые",
  "inbox12.channel.all": "Все",
  "inbox12.channel.telegram": "Telegram",
  "inbox12.channel.instagram": "Instagram DM",
  "inbox12.channel.instagram_comment": "Комментарии Instagram",
  "inbox12.search": "Имя, телефон или текст сообщения",
  "inbox12.noMatch": "Нет чатов под этот фильтр.",
  "inbox12.empty.title": "Чатов нет",
  "inbox12.empty.text": "Чат откроется здесь, когда клиент напишет. Первое сообщение можете написать и вы.",
  "inbox12.empty.action": "К клиентам",
  "inbox12.pick": "Выберите чат",
  "inbox12.select": "Выбрать для рассылки",
  "inbox12.bulk": "Рассылка ({count})",
  "inbox12.commentsPage": "Страница комментариев",
  "inbox12.row.late": "Просрочен · {status}",
  "inbox12.row.aiOff": "AI выключен",
  "inbox12.row.claim": "Взять",
  "inbox12.row.assign": "Назначить",
  "inbox12.row.need": "AI определил:",
  "inbox12.row.closed": "Закрыт · {outcome}",
  "inbox12.owner.label": "Ответственный:",
  "inbox12.owner.none": "не взят",
  "inbox12.owner.change": "Сменить ответственного",
  "inbox12.owner.pick": "Выберите ответственного",
  "inbox12.owner.done": "Ответственный: {name}",
  "inbox12.owner.failed": "Не удалось сменить ответственного.",
  "inbox12.owner.error": "Не удалось загрузить сотрудников.",
  "inbox12.owner.empty": "Некому передать.",
  "inbox12.give": "Передать другому",
  "inbox12.close": "Закрыть чат",
  "inbox12.closeShort": "Закрыть",
  "inbox12.client": "Клиент",
  "inbox12.claim.done": "{name}: назначен вам",
  "inbox12.deal.create": "Создать сделку",
  "inbox12.deal.open": "Открыть сделку",
  "inbox12.reopen": "Открыть снова",
  "inbox12.reopened": "Чат открыт снова",
  "inbox12.reopenFailed": "Не удалось открыть чат снова.",
  "inbox12.ai.offNote": "AI выключен · отвечает оператор",
  "inbox12.ai.turnedOff": "AI выключен · отвечает оператор",
  "inbox12.ai.turnedOn": "AI включён · первый ответ даст AI",
  "inbox12.ai.withNote": "Вернуть с указанием",
  "inbox12.ai.note": "Указание для AI (необязательно)",
  "inbox12.ai.return": "Пусть AI продолжит",
  "inbox12.ai.failed": "Не удалось сменить режим.",
  "inbox12.closeDialog.bought": "Купил тур",
  "inbox12.closeDialog.refused": "Отказался",
  "inbox12.closeDialog.went_quiet": "Перестал отвечать",
  "inbox12.closeDialog.spam": "Спам",
  "inbox12.closeDialog.toBooked": "Сделка перейдёт на этап «Бронь»",
  "inbox12.closeDialog.noBooking": "Брони нет: сделка останется на месте, будет создана задача",
  "inbox12.closeDialog.toLost": "Сделка перейдёт в «Потеряно» · причина: {reason}",
  "inbox12.closeDialog.quiet": "не ответил",
  "inbox12.closeDialog.toSpam": "Сделка не создаётся, чат уходит в архив",
  "inbox12.closeDialog.done": "Чат закрыт · {outcome}",
  "inbox12.closeDialog.failed": "Не удалось закрыть чат.",
  "inbox12.task.call": "Звонок",
  "inbox12.task.message": "Сообщение",
  "inbox12.task.document": "Документ",
  "inbox12.task.payment": "Оплата",
  "inbox12.task.followUp": "Обратная связь",
  "inbox12.task.add": "Добавить задачу",
  "inbox12.task.added": "Задача добавлена · {name}",
  "inbox12.task.failed": "Не удалось сохранить задачу.",
  "inbox12.task.completeFailed": "Не удалось закрыть задачу.",
  "inbox12.task.today": "Сегодня",
  "inbox12.panel.need": "выявленная потребность",
  "inbox12.panel.needField.destination": "Направление",
  "inbox12.panel.needField.dates": "Даты",
  "inbox12.panel.needField.party": "Туристы",
  "inbox12.panel.needField.service": "Услуга",
  "inbox12.panel.firstContact": "Первое обращение: {date}",
  "inbox12.panel.allChannels": "Сообщения во всех каналах",
  "inbox12.panel.thisThread": "Только этот чат",
  "inbox12.panel.more": "Подробнее: портрет, сделки, история",
  "inbox12.panel.closedAs": "Итог",
  "inbox12.composer.label": "Написать ответ",
  "inbox12.composer.text": "Сообщение",
  "inbox12.composer.placeholder": "Напишите сообщение. «/» шаблоны",
  "inbox12.composer.notePlaceholder": "Внутренняя заметка. Клиент не видит",
  "inbox12.composer.send": "Отправить",
  "inbox12.composer.sendNote": "Заметка",
  "inbox12.composer.needsClaim": "Чтобы ответить, сначала возьмите чат.",
  "inbox12.composer.chips": "Быстрые кнопки",
  "inbox12.draft.title": "Kapitan AI · черновик",
  "inbox12.card.page": "Страница предложения",
  "inbox12.card.nights": "{count} ноч.",
  "inbox12.card.pax": "{count} чел.",
  "inbox12.message.staffMeta": "{name} · {time}",
} as const;
